import React, { useState } from "react";
import "./portifolio.css";

import theuz from "../theuz/imgTheuz/theuz.png";
import cv from "../theuz/imgTheuz/cv.png";
import phone from "../theuz/imgTheuz/phone.png";
import linkedin from "../theuz/imgTheuz/linkedin.png";
import email from "../theuz/imgTheuz/email.png";

function Portifolio() {
  const [activePanel, setActivePanel] = useState(null);
  const [language, setLanguage] = useState("en");
  const [loading, setLoading] = useState(false);
  const [activeFlag, setActiveFlag] = useState("us");

  const handleLanguageChange = (lang, flag) => {
    if (language !== lang) {
      setLoading(true);
      setTimeout(() => {
        setLanguage(lang);
        setActiveFlag(flag);
        setLoading(false);
      }, 3000);
    }
  };

  const togglePanel = (panel) => {
    setActivePanel(activePanel === panel ? null : panel);
  };

  return (
    <>
      {loading && (
        <div className="loader-screen-pf">
          <div className="loading-overlay-pf">
            <div className="loader-pf">
              <svg viewBox="0 0 80 80">
                <circle r="32" cy="40" cx="40"></circle>
              </svg>
            </div>
            <div className="loader-pf triangle-pf">
              <svg viewBox="0 0 86 80">
                <polygon points="43 8 79 72 7 72"></polygon>
              </svg>
            </div>
            <div className="loader-pf">
              <svg viewBox="0 0 80 80">
                <rect height="64" width="64" y="8" x="8"></rect>
              </svg>
            </div>
          </div>
        </div>
      )}
      <header className="pf-header">
        <a href="http://www.theuz.eu" target="_blank" rel="noopener noreferrer">
          <img src={theuz} alt="logo" />
        </a>
        <div className="pf-flags">
          <img
            src="https://placehold.co/50x30?text=BR"
            alt="Bandeira Brasileira"
            className={activeFlag === "br" ? "flag-clicked" : ""}
            onClick={() => handleLanguageChange("pt", "br")}
          />
          <img
            src="https://placehold.co/50x30?text=US"
            alt="Bandeira Americana"
            className={activeFlag === "us" ? "flag-clicked" : ""}
            onClick={() => handleLanguageChange("en", "us")}
          />
        </div>
      </header>

      <main className="pf-main">
        <section className="pf-mainArea">
          <h1>
            {language === "en" ? (
              <>
                Hey,
                <br />
                I'm Matheus,
                <br />
                web developer
              </>
            ) : (
              <>
                Oi,
                <br />
                eu sou Matheus,
                <br />
                desenvolvedor web
              </>
            )}
          </h1>
          <p>
            {language === "en"
              ? "Front End Developer / Mobile App Developer"
              : "Desenvolvedor Front End / Mobile"}
          </p>
          <a>{language === "en" ? "Contact me!" : "Entre em contato!"}</a>

          <ul className="pf-wrapper">
            <li className="icon email">
              <span className="tooltip">Email</span>
              <a
                href="mailto:fg.matheuz@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={email} alt="Email" />
              </a>
            </li>
            <li className="icon phone">
              <span className="tooltip">Phone</span>
              <a
                href="https://wa.me/+351912371044"
                target="_blank"
                rel="noreferrer"
              >
                <img src={phone} alt="Phone" />
              </a>
            </li>
            <li className="icon linkedin">
              <span className="tooltip">Linkedin</span>
              <a
                href="https://www.linkedin.com/in/matheuz-franca/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkedin} alt="Linkedin" />
              </a>
            </li>
            <li className="icon cv">
              <span className="tooltip">CV</span>
              <a
                href={
                  language === "en"
                    ? "https://drive.google.com/file/d/1pMIxfrUiPnO-VAEVC_vTAdWoEkpYhxbi/view?usp=sharing"
                    : "https://drive.google.com/file/d/1qyKqKG6qgReg73RAoO9W-JybLJ8a4gSX/view?usp=sharing"
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={cv} alt="CV" />
              </a>
            </li>
          </ul>

          <div className="pf-directions">
            <p>←</p>
            <p>{language === "en" ? "Projects" : "Projetos"}</p>
            <span>|</span>
            <p>{language === "en" ? "Skills" : "Conhecimentos"}</p>
            <p>→</p>
          </div>
        </section>

        <aside
          className={`pf-esquerda ${activePanel === "left" ? "open" : ""}`}
        >
          <button className="toggle-left" onClick={() => togglePanel("left")}>
            {activePanel === "left" ? "←" : "→"}
          </button>

          <h2>{language === "en" ? "Projects" : "Projetos"}</h2>
          <h3>Web Site</h3>
          <p>
            {language === "en"
              ? "My projects focus on usability. I use minimalist designs to make navigation more intuitive and objective, in addition to responsiveness."
              : "Meus projetos focam na usabilidade, utilizo designs minimalistas para tornar mais objetivo e intuitiva a navegação do usuário, além da responsividade."}
          </p>

          <h3 className="pf-t-right">API's</h3>
          <p>
            {language === "en"
              ? "Integrations with Google, Stripe, and other services are actively present in my projects."
              : "Integrações com google, stripe e outros serviços estão presentes nos meus projetos ativamente."}
          </p>

          <h3>Mobile</h3>
          <p>
            {language === "en"
              ? "Although few, my apps aim to deliver a functional and intuitive product, integrating payment methods and other services."
              : "Apesar de poucos, meus apps visam entregar um produto funcional e o mais intuitivo possivel fazendo integrações com meios de pagamentos e outros serviços."}
          </p>

          <h3 className="pf-t-right">SEO</h3>
          <p>
            {language === "en"
              ? "Knowledge in on-site SEO, maximizing content loading speed, keywords, and other methods to make the site more responsive to search engines."
              : "Conhecimentos em SEO on-site maximizando a velocidade de carregamento de conteúdo, palavras chave e outros meios para tornar o site o mais responsivo aos meios de busca."}
          </p>

          <h4>
            {language === "en" ? (
              <>
                For more <strong>information</strong> about my{" "}
                <strong>projects</strong>, click here.
              </>
            ) : (
              <>
                Para mais <strong>informações</strong> dos meus{" "}
                <strong>projetos</strong> clique aqui.
              </>
            )}
          </h4>
          <a
            href="http://www.theuz.eu"
            target="_blank"
            rel="noopener noreferrer"
          >
            {language === "en" ? "Visit" : "Visite"}
          </a>
        </aside>

        <aside
          className={`pf-direita ${activePanel === "right" ? "open" : ""}`}
        >
          <button className="toggle-right" onClick={() => togglePanel("right")}>
            {activePanel === "right" ? "→" : "←"}
          </button>

          <h2>{language === "en" ? "Skills" : "Conhecimentos"}</h2>
          <h3>{language === "en" ? "Languages" : "Linguagens"}</h3>

          <div className="pf-linguagens">
            <div>
              <p>{language === "en" ? "Web" : "Web"}</p>
              <div className="pf-lgg">
                <span>HTML + CSS</span>
                <span>|</span>
                <span>React.js</span>
              </div>
            </div>

            <div>
              <p>{language === "en" ? "Server" : "Servidor"}</p>
              <span>Node</span>
            </div>

            <div>
              <p>{language === "en" ? "Mobile" : "Mobile"}</p>
              <span>React Native</span>
            </div>

            <div>
              <p>{language === "en" ? "Database" : "Banco de Dados"}</p>
              <span>SQLite</span>
            </div>
          </div>

          <p>
            {language === "en" ? (
              <>
                My knowledge is based on <strong>online courses</strong>,{" "}
                <strong>educational videos</strong>, <strong>forums</strong>,
                and <strong>experience</strong> throughout my journey.
              </>
            ) : (
              <>
                Meu conhecimento se baseia em <strong>cursos online</strong>,{" "}
                <strong>vídeos educativos</strong>, <strong>fóruns</strong> e{" "}
                <strong>experiência</strong> ao longo da minha trajetória.
              </>
            )}
          </p>

          <p>
            {language === "en" ? (
              <>
                The projects I have completed use <strong>custom APIs</strong>{" "}
                or services from <strong>big tech companies</strong>. My focus
                as a <strong>web developer</strong> is on{" "}
                <strong>project functionality</strong> and{" "}
                <strong>user experience</strong>, which is why I don't place a
                strong emphasis on <strong>databases</strong>.
              </>
            ) : (
              <>
                Os projetos que realizei utilizam de{" "}
                <strong>APIs próprias</strong> ou de serviços de{" "}
                <strong>big techs</strong>. Meu foco como{" "}
                <strong>Web Developer</strong> é com a{" "}
                <strong>funcionalidade do projeto</strong> e{" "}
                <strong>usabilidade do usuário</strong>, por conta disso, não
                tenho um grande foco em <strong>banco de dados</strong>.
              </>
            )}
          </p>

          <h4>
            {language === "en" ? (
              <>
                For more <strong>information</strong> about my{" "}
                <strong>projects</strong>, click here.
              </>
            ) : (
              <>
                Para mais <strong>informações</strong> dos meus{" "}
                <strong>projetos</strong>, clique aqui.
              </>
            )}
          </h4>

          <a
            href="http://www.theuz.eu"
            target="_blank"
            rel="noopener noreferrer"
          >
            {language === "en" ? "Visit" : "Visite"}
          </a>
        </aside>
      </main>
    </>
  );
}

export default Portifolio;
